export interface Currency {
  acronym: string
  prefix: string
}

export interface IsoCountry {
  iso: string
  name: string
  currency: string
}

export interface Price {
  price_id: string
  unit_amount: number
  currency: string
}

export interface Product {
  prices: {
    [key: string]: Price
  }
}

export type ProductDuration = "monthly" | "annually"

export type Products = Record<ProductDuration, Product>

export interface PaymentProfile {
  card_last_4: number
  card_exp_year: number
  card_exp_month: number
  subscription_currency: string
  subscription_unit_amount: number
  subscription_interval: string
}

export interface Support {
  currencies: Currency[]
  iso_countries: IsoCountry[]
  default_iso_country: string
  products: Products
  stripe_publishable_key: string
  messages: Record<string, string>
  features: {
    promo_code_field: boolean
  }
  user: {
    email: string
    premium: boolean
    signedIn: boolean
    emailVerified: boolean
    forcedCurrency: string
    paymentProfile?: PaymentProfile
    premiumExpires: number | null
  }
  experiment: number
}

export function savePercent(products: Products, currencyAcronym: string): number {
  return Math.round(
    ((Number(products.monthly.prices[currencyAcronym].unit_amount) * 12 -
      Number(products.annually.prices[currencyAcronym].unit_amount)) /
      (Number(products.monthly.prices[currencyAcronym].unit_amount) * 12)) *
      100,
  )
}
